export enum WhatsNewCardStatus {
    Read = 'Read',
    Unread = 'Unread',
}
